import { PROCESS_STEPS } from '../data/content';

export const Workflow = () => (
  <section id="workflow" className="py-24 px-6 bg-[#0A192F]">
    <div className="max-w-7xl mx-auto">
      <div className="text-center mb-16">
        <h2 className="text-3xl font-bold text-white mb-4">No complicated processes.</h2>
        <p className="text-slate-400">From problem to solution in three simple steps.</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
        {/* Connection Line (Desktop Only) */}
        <div className="hidden md:block absolute top-10 left-0 w-full h-0.5 bg-slate-800 -z-0" />
        
        {PROCESS_STEPS.map((item) => (
          <div key={item.step} className="relative z-10 flex flex-col items-center text-center">
            <div className="w-20 h-20 bg-blue-600 text-white rounded-full flex items-center justify-center text-2xl font-black mb-6 shadow-xl shadow-blue-600/20 border-4 border-[#0A192F]">
              {item.step}
            </div>
            <h3 className="text-xl font-bold text-white mb-3">{item.title}</h3>
            <p className="text-sm text-slate-400 leading-relaxed px-4">
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);